import { guestSessionManager } from './apiCall';

/**
 * Utility functions for managing guest sessions across the application
 */

/**
 * Initialize guest session on app startup
 * This should be called early in the application lifecycle
 */
export const initializeGuestSession = async () => {
  try {
    // Ensure we have a valid guest session
    const sessionId = await guestSessionManager.getGuestSession();
    console.log('Guest session initialized:', sessionId);
    return sessionId;
  } catch (error) {
    console.error('Failed to initialize guest session:', error);
    return null;
  }
};

/**
 * Get current guest session ID without creating a new one
 */
export const getCurrentGuestSession = () => {
  return guestSessionManager.getExistingSession();
};

/**
 * Check if current session is a guest session
 */
export const isGuestSession = () => {
  const token = localStorage.getItem('token');
  return !token;
};

/**
 * Safely clear guest session (used when user logs in)
 */
export const clearGuestSession = () => {
  guestSessionManager.clearSession();
};

/**
 * Refresh guest session (useful for debugging or session recovery)
 */
export const refreshGuestSession = async () => {
  try {
    const sessionId = await guestSessionManager.getGuestSession();
    console.log('Guest session refreshed:', sessionId);
    return sessionId;
  } catch (error) {
    console.error('Failed to refresh guest session:', error);
    return null;
  }
};

/**
 * Get session info for debugging
 */
export const getSessionInfo = () => {
  const primary = localStorage.getItem('guestSessionId');
  const backup = localStorage.getItem('guestSessionBackup');
  const session = sessionStorage.getItem('guestSessionId');
  const lastUsed = localStorage.getItem('guestSessionLastUsed');
  
  return {
    primary,
    backup,
    session,
    lastUsed: lastUsed ? new Date(parseInt(lastUsed)).toISOString() : null,
    isValid: guestSessionManager.isSessionValid(primary)
  };
};

/**
 * Force recovery of guest session from database
 */
export const forceSessionRecovery = async () => {
  try {
    const sessionId = await guestSessionManager.recoverSessionFromDatabase();
    if (sessionId) {
      console.log('Session recovered from database:', sessionId);
      return sessionId;
    } else {
      console.log('No valid session found in database');
      return null;
    }
  } catch (error) {
    console.error('Failed to force session recovery:', error);
    return null;
  }
};

/**
 * Check if guest session has cart items
 */
export const hasCartItems = async () => {
  try {
    const sessionId = getCurrentGuestSession();
    if (!sessionId) return false;
    
    const response = await guestSessionManager.testSessionValidity(sessionId);
    return response;
  } catch (error) {
    console.error('Failed to check cart items:', error);
    return false;
  }
};

export default {
  initializeGuestSession,
  getCurrentGuestSession,
  isGuestSession,
  clearGuestSession,
  refreshGuestSession,
  getSessionInfo,
  forceSessionRecovery,
  hasCartItems
};
